import React, { useState, useEffect, useRef } from "react";
import ScrollArea from "react-scrollbars-custom";
import classNames from "classnames";
import { compose } from "redux";

import connectProps from "fantastic/lib/connectProps";
import connectActions from "fantastic/lib/connectActions";
import CollectionEntity from "./elements/CollectionEntity";

import favoriteQuery from "fantastic/actions/favoriteQuery";
import loadCollections from "fantastic/actions/loadCollections";

import QuerySearch from "./QuerySearch";

const ElementsBar = ({
  collections: { elements, query, tags, selectedTags, reloadRequired = false },
  handleClose,
  loadCollections,
  favoriteQuery
}) => {
  const scrollRef = useRef(null);

  const [page, setPage] = useState(0);

  const scrollToIfNeeded = element => {
    scrollRef.current.scrollTo(0, element.offsetTop);
  };

  useEffect(() => {
    load();
    return () => {};
  }, [query, selectedTags]);

  useEffect(() => {
    if(!reloadRequired) return;
    load();
  }, [reloadRequired]);

  const load = () => {
    setPage(0);
    loadCollections(query, selectedTags);
  };

  const filteredTags = tags.filter(t => t !== i18n.t('my_blocks'));

  const handleScroll = ({ clientHeight, scrollTop, scrollHeight }) => {
    const isEndReached = clientHeight + scrollTop >= scrollHeight;
    if (isEndReached) {
      setPage(page + 1);
      loadCollections(query, selectedTags, page + 1);
    }
  }

  return (
    <>
      <div className="fantastic-elements-bar__header">
        <div className="fantastic-elements-bar__caption">
          { i18n.t('elements') }
        </div>
        <a
          className="btn btn-default fantastic-sidebar__close"
          onClick={handleClose}
        >
          <i className="fa fa-remove" />
        </a>
      </div>
      <QuerySearch
        query={query}
        onChange={(q, t) => favoriteQuery(q, t)}
        tags={filteredTags}
        selectedTags={selectedTags}
      />
      <div className="fantastic-elements-bar__collection">
        <ScrollArea noDefaultStyles={true} ref={scrollRef} onScrollStop={handleScroll}>
          <CollectionEntity elements={elements} />
        </ScrollArea>
      </div>
    </>
  );
};

export default compose(
  connectActions({ favoriteQuery, loadCollections }),
  connectProps("collections")
)(ElementsBar);
